// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Navbar_dropdown__1rC1_","dropbtn":"Navbar_dropbtn__170cd","navbar":"Navbar_navbar__1hejU","active":"Navbar_active__2rhy8"};